import styled from 'styled-components';

export const MainContainer = styled.div`
  padding: 20px;
  max-width: 700px;
`;

export const DetailsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
  padding-bottom: 5px;
`;

export const DetailTitle = styled.span`
  font-weight: 600;
`;

export const DetailText = styled.span`
  color: #333;
`;